"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisementSeek = exports.SeekingRestrictionKey = exports.AdvertisementSelection = exports.SeekingRestriction = void 0;
var SeekingRestriction;
(function (SeekingRestriction) {
    SeekingRestriction["UNRESTRICTED"] = "unrestricted";
    SeekingRestriction["NO_FORWARD"] = "noForward";
    SeekingRestriction["NO_SEEKING"] = "noSeeking";
})(SeekingRestriction || (exports.SeekingRestriction = SeekingRestriction = {}));
var AdvertisementSelection;
(function (AdvertisementSelection) {
    AdvertisementSelection["NONE"] = "none";
    AdvertisementSelection["LAST"] = "last";
    AdvertisementSelection["ALL"] = "all";
})(AdvertisementSelection || (exports.AdvertisementSelection = AdvertisementSelection = {}));
var SeekingRestrictionKey;
(function (SeekingRestrictionKey) {
    SeekingRestrictionKey["CONTENT_SEEK"] = "contentSeek";
    SeekingRestrictionKey["UNSKIPPABLE_SEEK"] = "unskippableSeek";
    SeekingRestrictionKey["SKIPPABLE_SEEK"] = "skippableSeek";
    SeekingRestrictionKey["DISABLED"] = "disabled";
})(SeekingRestrictionKey || (exports.SeekingRestrictionKey = SeekingRestrictionKey = {}));
var AdvertisementSeek;
(function (AdvertisementSeek) {
    AdvertisementSeek["UNRESTRICTED"] = "unrestricted";
    AdvertisementSeek["SKIPPABLE"] = "skippable";
    AdvertisementSeek["STRICT"] = "strict";
})(AdvertisementSeek || (exports.AdvertisementSeek = AdvertisementSeek = {}));
//# sourceMappingURL=ISeekingRestrictions.js.map